import React from 'react'
import { connect } from 'react-redux'
import { getSidebarOpened } from '@/store/getters'
import { toggleSidebar } from '@/store/actions'
import { elementTypes } from '@/components/commons/editor/configs/ElementTypes'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'
import { PopOver } from '@/components/commons/PopOver'

const ShapeComponent = props => {
  const { toggleSidebar, onAddElement, sidebarOpened } = props
  const { isOpened, name } = sidebarOpened

  return (
    isOpened && name === 'shapes' &&
    <PopOver
      className={`${styles['wrapper-shapes']}`}
      hidePopover={() =>
        toggleSidebar({
          isOpened: true,
          name: 'layers'
        })
      }
    >
      <p className='ba-font'>Shapes</p>
      <hr className="ba-hr ba-mg-b-1" />
      <div className={styles['wrapper-shapes__geometric']}>
        <button onClick={() => onAddElement(elementTypes.SQUARE)}>
          <IconComponent icon="square" />
        </button>

        <button onClick={() => onAddElement(elementTypes.CIRCLE)}>
          <IconComponent icon="circle" />
        </button>

        <button onClick={() => onAddElement(elementTypes.TRIANGLE)}>
          <IconComponent icon="triangle" />
        </button>

        <button onClick={() => onAddElement(elementTypes.RHOMBUS)}>
          <IconComponent icon="rhombus" />
        </button>

        <button className={'ba-pd-y-4'} onClick={() => onAddElement(elementTypes.LINE)}>
          <IconComponent icon="line" />
        </button>

        <button className={'ba-pd-y-4'} onClick={() => onAddElement(elementTypes.ARROW)}>
          <IconComponent icon="shape-arrow" />
        </button>

        <button onClick={() => onAddElement(elementTypes.STAR)}>
          <IconComponent icon="shape-star" />
        </button>
      </div>
    </PopOver>
  )
}

const mapStateToProps = state => {
  const sidebarOpened = getSidebarOpened(state)
  return { sidebarOpened }
}

export default connect(
  mapStateToProps,
  { toggleSidebar }
)(ShapeComponent)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/Shapes/index.js